export default "__VITE_ASSET__AfdUxIiI__"